
import Vue from 'vue'

const locales = {keys(){return []}}
global['____1BBE902____'] = true;
delete global['____1BBE902____'];
global.__uniConfig = {"easycom":{"autoscan":true,"custom":{"^tn-(.*)":"tuniao-ui/components/tn-$1/tn-$1.vue","^uni-(.*)":"@dcloudio/uni-ui/lib/uni-$1/uni-$1.vue","^unicloud-db$":"@dcloudio/uni-cli-shared/components/unicloud-db.vue","^uniad$":"@dcloudio/uni-cli-shared/components/uniad.vue","^ad-rewarded-video$":"@dcloudio/uni-cli-shared/components/ad-rewarded-video.vue","^ad-fullscreen-video$":"@dcloudio/uni-cli-shared/components/ad-fullscreen-video.vue","^ad-interstitial$":"@dcloudio/uni-cli-shared/components/ad-interstitial.vue","^ad-interactive$":"@dcloudio/uni-cli-shared/components/ad-interactive.vue","^page-meta$":"@dcloudio/uni-cli-shared/components/page-meta.vue","^navigation-bar$":"@dcloudio/uni-cli-shared/components/navigation-bar.vue","^uni-match-media$":"@dcloudio/uni-cli-shared/components/uni-match-media.vue"}},"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"号卡商城","navigationBarBackgroundColor":"#F8F8F8","backgroundColor":"#F8F8F8"},"tabBar":{"color":"#666666","selectedColor":"#667eea","backgroundColor":"#ffffff","borderStyle":"white","height":"80px","fontSize":"12px","iconWidth":"28px","spacing":"8px","list":[{"pagePath":"pages/index/index","text":"首页","iconPath":"static/tabbar/home.svg","selectedIconPath":"static/tabbar/home-active.svg","redDot":false,"badge":""},{"pagePath":"pages/product/index","text":"产品","iconPath":"static/tabbar/product.svg","selectedIconPath":"static/tabbar/product-active.svg","redDot":false,"badge":""},{"pagePath":"pages/order/index","text":"订单","iconPath":"static/tabbar/order.svg","selectedIconPath":"static/tabbar/order-active.svg","redDot":false,"badge":""},{"pagePath":"pages/downline/index","text":"团队","iconPath":"static/tabbar/downline.svg","selectedIconPath":"static/tabbar/downline-active.svg","redDot":false,"badge":""},{"pagePath":"pages/user/index","text":"我的","iconPath":"static/tabbar/user.svg","selectedIconPath":"static/tabbar/user-active.svg","redDot":false,"badge":""}]},"uniIdRouter":{}};
global.__uniConfig.compilerVersion = '4.56';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__1BBE902';
global.__uniConfig.appName = '';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"hash","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-login-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/login/index"+'.vue')), 'pages-login-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-register', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/login/register"+'.vue')), 'pages-login-register'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/product/index"+'.vue')), 'pages-product-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/order/index"+'.vue')), 'pages-order-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-downline-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/downline/index"+'.vue')), 'pages-downline-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/user/index"+'.vue')), 'pages-user-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-agreement-user', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/agreement/user"+'.vue')), 'pages-agreement-user'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-agreement-privacy', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/agreement/privacy"+'.vue')), 'pages-agreement-privacy'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-wallet-withdraw', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/wallet/withdraw"+'.vue')), 'pages-wallet-withdraw'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-verify', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/user/verify"+'.vue')), 'pages-user-verify'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-balance', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/user/balance"+'.vue')), 'pages-user-balance'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-ticket-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/ticket/index"+'.vue')), 'pages-ticket-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-wechat', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/user/wechat"+'.vue')), 'pages-user-wechat'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-help-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/help/index"+'.vue')), 'pages-help-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-profile-edit', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/profile/edit"+'.vue')), 'pages-profile-edit'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-about-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/about/index"+'.vue')), 'pages-about-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-notice-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/notice/index"+'.vue')), 'pages-notice-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-message-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/message/index"+'.vue')), 'pages-message-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-invite-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/invite/index"+'.vue')), 'pages-invite-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-shop-settings', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/AAAAAAAAAAAA/demo/H5/pages/shop/settings"+'.vue')), 'pages-shop-settings'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/login/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"登录"})
      },
      [
        createElement('pages-login-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-login-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/index',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/login/register',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"注册"})
      },
      [
        createElement('pages-login-register', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-register',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/register',
  windowTop:0
}
},
{
path: '/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"首页"})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:2,
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
isQuit:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:0
}
},
{
path: '/pages/product/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:1
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"产品中心"})
      },
      [
        createElement('pages-product-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:3,
  name:'pages-product-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/index',
isQuit:true,
isTabBar:true,
tabBarIndex:1,
  windowTop:0
}
},
{
path: '/pages/order/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:2
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"订单管理"})
      },
      [
        createElement('pages-order-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:4,
  name:'pages-order-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/index',
isQuit:true,
isTabBar:true,
tabBarIndex:2,
  windowTop:0
}
},
{
path: '/pages/downline/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:3
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"我的团队"})
      },
      [
        createElement('pages-downline-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:5,
  name:'pages-downline-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/downline/index',
isQuit:true,
isTabBar:true,
tabBarIndex:3,
  windowTop:0
}
},
{
path: '/pages/user/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:4
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"个人中心"})
      },
      [
        createElement('pages-user-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:6,
  name:'pages-user-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/index',
isQuit:true,
isTabBar:true,
tabBarIndex:4,
  windowTop:0
}
},
{
path: '/pages/agreement/user',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"用户协议"})
      },
      [
        createElement('pages-agreement-user', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-agreement-user',
  isNVue:false,maxWidth:0,
  pagePath:'pages/agreement/user',
  windowTop:44
}
},
{
path: '/pages/agreement/privacy',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"隐私政策"})
      },
      [
        createElement('pages-agreement-privacy', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-agreement-privacy',
  isNVue:false,maxWidth:0,
  pagePath:'pages/agreement/privacy',
  windowTop:44
}
},
{
path: '/pages/wallet/withdraw',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"提现"})
      },
      [
        createElement('pages-wallet-withdraw', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-wallet-withdraw',
  isNVue:false,maxWidth:0,
  pagePath:'pages/wallet/withdraw',
  windowTop:0
}
},
{
path: '/pages/user/verify',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"实名认证"})
      },
      [
        createElement('pages-user-verify', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-verify',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/verify',
  windowTop:0
}
},
{
path: '/pages/user/balance',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"我的钱包"})
      },
      [
        createElement('pages-user-balance', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-balance',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/balance',
  windowTop:0
}
},
{
path: '/pages/ticket/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"工单中心"})
      },
      [
        createElement('pages-ticket-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-ticket-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/ticket/index',
  windowTop:0
}
},
{
path: '/pages/user/wechat',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"微信绑定"})
      },
      [
        createElement('pages-user-wechat', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-wechat',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/wechat',
  windowTop:0
}
},
{
path: '/pages/help/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"帮助中心"})
      },
      [
        createElement('pages-help-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-help-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/help/index',
  windowTop:0
}
},
{
path: '/pages/profile/edit',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"编辑资料"})
      },
      [
        createElement('pages-profile-edit', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-profile-edit',
  isNVue:false,maxWidth:0,
  pagePath:'pages/profile/edit',
  windowTop:0
}
},
{
path: '/pages/about/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"关于我们"})
      },
      [
        createElement('pages-about-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-about-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/about/index',
  windowTop:0
}
},
{
path: '/pages/notice/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"通知公告"})
      },
      [
        createElement('pages-notice-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-notice-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/notice/index',
  windowTop:0
}
},
{
path: '/pages/message/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"消息中心"})
      },
      [
        createElement('pages-message-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-message-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/message/index',
  windowTop:0
}
},
{
path: '/pages/invite/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"邀请好友"})
      },
      [
        createElement('pages-invite-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-invite-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/invite/index',
  windowTop:0
}
},
{
path: '/pages/shop/settings',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"店铺设置"})
      },
      [
        createElement('pages-shop-settings', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-shop-settings',
  isNVue:false,maxWidth:0,
  pagePath:'pages/shop/settings',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
